import SVG from './SVG'

export const EmailSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="mail">
        <path
          fillRule="evenodd"
          d="M3.107 5.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779 3.107 5.554ZM1 5.98V18c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6.009m-2 1.912V18c0 .548-.452 1-1 1H4c-.548 0-1-.452-1-1V7.92l8.427 5.9a1 1 0 0 0 1.146 0L21 7.92Zm2-1.935A3.006 3.006 0 0 0 20 3H4a3.006 3.006 0 0 0-3 2.98"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
